import { USER_ROLES } from '../../auth/index';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
];

export default {
	CUSTOMERS: {
		ACTIVE: true,
		INTERNAL: true,
		NAME: 'customers',
		LABEL: 'Customers',
		ICON: 'interface-home',
		PATH: '/customers/:section',
		CHILDREN: ['CUSTOMERS_LIST', 'CUSTOMERS_ACTIVATION'],
		PERMISSIONS,
	},

	CUSTOMERS_LIST: {
		ACTIVE: true,
		INTERNAL: true,
		NAME: 'customers-list',
		LABEL: 'Customers List',
		PARAMS: {
			section: 'list',
		},
		PERMISSIONS,
	},
	CUSTOMERS_ACTIVATION: {
		ACTIVE: true,
		INTERNAL: true,
		NAME: 'customers-activation',
		LABEL: 'Customer Activation',
		PARAMS: {
			section: 'activate/:id',
		},
		PERMISSIONS,
	},
};
